(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabPropertiesDialogController', TabPropertiesDialogController);

    TabPropertiesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TabProperties'];

    function TabPropertiesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TabProperties) {
        var vm = this;
        vm.tabProperties = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabPropertiesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabProperties.id !== null) {
                TabProperties.update(vm.tabProperties, onSaveSuccess, onSaveError);
            } else {
                TabProperties.save(vm.tabProperties, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
